<template>
  <div>
    <b-modal
      id="edit-state-modal"
      ref="edit-state-modal"
      size="md"
      @hidden="cancel"
      :title="$t('modals.updateState.text')"
    >
      <!-- Name -->
      <div class="row">
        <div class="col-12 col-lg-12">
          <label for="name">{{$t("modals.name.text")}}</label>
          <b-form-input
            id="name"
            v-model="stateEdit.name"
            class="mb-1"
            :placeholder="$t('modals.name.text')"
            :state="err.name ? false : null"
          ></b-form-input>
          <b-form-invalid-feedback>
            {{ err.name }}
          </b-form-invalid-feedback>
        </div>
      </div>

      <!-- isClosed -->
      <div class="row">
        <div class="col-12 col-lg-12 text-right">
          <b-form-checkbox
            id="isClosed"
            v-model="stateEdit.isClosed"
            name="isClosed"
            :value="true"
            :unchecked-value="false"
          >
          {{$t("modals.isClosed.text")}}
          </b-form-checkbox>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div class="row p-2">
          <div class="col-10 text-right p-1">
            <b-button variant="success" class="text-white" @click="edit(ok)">
              {{$t("buttons.update.text")}}
            </b-button>
          </div>
          <div class="col-2 text-center p-1">
            <b-button @click="cancel()"> {{$t("buttons.cancel.text")}} </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["state"],
  created() {},
  data() {
    return {
      stateEdit: {
        stateId: null,
        name: null,
        isClosed: false,
      },
      err: {
        name: null,
      },
    };
  },
  watch: {
    state(newVal) {
      this.stateEdit = {
        stateId: newVal.id,
        name: newVal.name,
        isClosed: newVal.isClosed,
      };
    },
  },
  methods: {
    cancel() {
      this.clear();
    },
    clear() {
      /* this.stateEdit = {
        stateId: null,
        name: null,
      }; */
      this.err = {
        name: null,
      };
    },
    edit(ok) {
      if (!this.stateEdit.name) this.err.name = this.$t("msgError.obligField.text");
      else this.err.name = "";

      if (!this.err.name) {
        if (this.stateEdit.name != this.state.name || this.stateEdit.isClosed != this.state.isClosed) {
          ok();
          this.$emit("editState", this.stateEdit);
        } else {
          ok();
        }
      }
    },
  },
};
</script>